
export default {
  name: "FlowButton",
  functional:true,
  props: {
    button: {
      type: Object,
      default() {
        return {};
      }
    },
    owner: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  render(h, _vm) {
    let props = _vm.props;
    return (
      <el-popover vModel={props.button.popVisible} popper-class="ds-morebutton-popover" trigger="manual" placement="top" class={["ds-button__flow"]}>
        {renderFlowButton(h, _vm)}
        {renderMainButton(h, _vm)}
      </el-popover>
    );
  }
};
function renderFlowButton(h, _vm) {
  let props = _vm.props;
  if (props.owner.flowButtons.length > 0) {
    return (
      <el-row style={{ width: props.owner.flowButtons.length > 5 ? "240px" : "80px" }}>
        {_.map(props.owner.flowButtons, (flow, index) => {
          return (
            <el-col key={`flowButtons_${index}`} span={props.owner.flowButtons.length > 5 ? 8 : 24} style="width: 80px; margin-bottom: 5px; margin-top: 5px">
              <DsfButton
                key="`isLinkSend_${index}`"
                style="width: 80px; margin-bottom: 5px; margin-top: 5px"
                icon="props.owner.getIcon(flow)"
                disabled="flow.disabled"
                size="props.owner.size"
                type="flow.type"
                title="flow.title"
                icon-position="flow.iconPosition"
                btn-style="'icon-text'"
                hasChild="props.owner.hasChild(flow)"
                on-click={props.owner.clickHandler(flow, $event)}
              >
                {flow.text}
              </DsfButton>
            </el-col>
          );
        })}
      </el-row>
    );
  }
}
function renderMainButton(h, _vm) {
  let props = _vm.props;
  return (
    <DsfButton
      slot="reference"
      icon={props.owner.getIcon(props.button)}
      title={props.button.title}
      disabled={props.button.disabled}
      icon-position={props.button.iconPosition}
      size="size"
      type={props.button.type}
      btn-style={props.button.btnStyle}
      on-click={() => props.owner.addFlowBtns(props.button)}
    >
      {props.button.text}
    </DsfButton>
  );
}